import React, { useEffect, useState } from 'react'
import { ListaRendiciones } from './Contenido/ListaRendiciones'
import { useParams } from 'react-router-dom'
import { getAdjuntosSolicitudAdapter } from '../../../../services/adapters/autorizaciones.adapter'
import { getAdjuntoPorId, getAdjuntosSolicitudService } from '../../../../services/autorizaciones/autorizaciones.service'
import { IconButton } from '@artprov/design-system'

export default function Autorizacion() {
    const [adjuntos, setAdjuntos] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [adjunto, setAdjunto] = useState(null)
    const { id } = useParams()

    const rendicionesAdaptedToDom = (adjuntos = []) => {
        const rendicionesAdaptedToDom = adjuntos.map((item) => {
            const accionDomElement = React.createElement(IconButton, {
                icon: "visibility",
                tooltip: "Subir comprobante",
                size: "medium",
                className: "text-primary-20",
                idfile: item.ID_FILE_COMPROBANTE,
                onClick: async () => {
                    const data = await getAdjuntoPorId(item.ID_FILE_COMPROBANTE)
                    setAdjunto(data || {})
                    setIsModalOpen(true)
                },
            });
            return { ...item, acciones: accionDomElement };
        });
        return rendicionesAdaptedToDom;
    };

    const getAdjuntosSolicitud = async (id) => {
        const { comprobantes } = await getAdjuntosSolicitudService(id)
        const data = getAdjuntosSolicitudAdapter(comprobantes)
        const adjuntosData = rendicionesAdaptedToDom(data)
        setAdjuntos(adjuntosData)
    };

    function closeModal() {
        setIsModalOpen(false);
    }

    useEffect(() => {
        getAdjuntosSolicitud(id)
        return setAdjuntos([])
    }, [])

    return (
        <ListaRendiciones adjuntos={adjuntos} isModalOpen={isModalOpen} closeModal={closeModal} adjunto={adjunto} />
    )
}
